<template>
  <div v-if="userData?.name" id="account-bar">    
    <span v-if="isDev" class="debug-info">({{ deviceType }})</span>
    <i class="fa fa-user"></i>&nbsp;
    <i>logged in as <b>{{ userData.name }}</b></i>&nbsp;|&nbsp;
    <a href="#" @click.prevent="handleLogout">Log out</a>    
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useUserStore } from '~/store/userStore';

const userStore = useUserStore();

const userData = computed(() => userStore.userData);

import { useLogoutAndClearCart } from '~/composables/useLogout';

const { logoutAndClearCart } = useLogoutAndClearCart();

const handleLogout = async () => {
  await logoutAndClearCart();
};

// Determine device type for debugging
const deviceType = ref("");

const updateDeviceType = () => {
  const width = window.innerWidth;  // Get viewport width
  const height = window.innerHeight; // Get viewport height

  if (window.matchMedia(`(max-width: 480px)`).matches) {
    deviceType.value = `phone - ${width}x${height}`;
  } else if (window.matchMedia(`(min-width: 481px) and (max-width: 1024px)`).matches) {
    deviceType.value = `tablet - ${width}x${height}`;
  } else if (window.matchMedia(`(min-width: 1025px) and (max-width: 1799px)`).matches) {
    deviceType.value = `desktop - ${width}x${height}`;
  } else {
    deviceType.value = `large-desktop - ${width}x${height}`;
  }
}

const isDev = process.env.NODE_ENV === 'development'; // Check if environment is development

onMounted(() => {
  updateDeviceType();
  window.addEventListener('resize', updateDeviceType);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateDeviceType);
});
</script>

<style scoped lang="scss">
@import '~/assets/constants.scss';

#account-bar {
  background: linear-gradient(to bottom, $fa-orange, $fa-dark-orange);
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem 2rem 0.5rem 0;
  font-size: 1rem;
  color: $light-white;
  border-top: 1px solid gray;

  a {
    color: $light-white;
  }

  .debug-info {
    margin-left: 1rem;
    font-weight: bold;
    color: $fa-blue; // make it stand out
  }
}
</style>
